import { useQuery } from '@tanstack/react-query';
import { userService } from '@/services/userService';

const normalizeUserResponse = (response) => {
  if (!response) return [];
  
  // Axios nests the actual response body inside a 'data' property
  const body = response.data || response;
  
  if (Array.isArray(body)) return body;
  if (Array.isArray(body.data)) return body.data;
  if (Array.isArray(body.teams)) return body.teams;
  if (Array.isArray(body.employees)) return body.employees;
  if (Array.isArray(body.users)) return body.users;
  
  return [];
};

export const useUsers = (params = {}) => {
  const query = useQuery({
    queryKey: ['users', params],
    queryFn: async () => {
      const response = await userService.getUsers(params);
      return normalizeUserResponse(response);
    },
    keepPreviousData: true,
  });

  return {
    teamMembers: query.data || [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};




